module.exports = __webpack_public_path__ + "img/showStatus3.da45f75a.png";